import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-530274ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-pre-header" }
const _hoisted_2 = { class: "d-flex justify-content-center justify-content-md-start" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione a operação", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "custom-options-right d-flex" }
const _hoisted_10 = { class: "header-right-side d-flex align-items-center justify-content-center" }
const _hoisted_11 = { class: "profile-dropdown d-flex justify-content-end" }
const _hoisted_12 = {
  class: "text-end fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "title d-lg-block" }
const _hoisted_14 = { class: "d-block fw-bold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, "Admin", -1))
const _hoisted_16 = { class: "dropdown dropdown-menu rounded-0 bg-white border-0 end-0 ps-10 radius-7" }
const _hoisted_17 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_18 = {
  key: 0,
  class: "text-body-secondary fw-semibold transition position-relative"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "pointer text-body-secondary fw-semibold transition position-relative",
  "data-bs-toggle": "modal",
  "data-bs-target": "#verticallyCenteredModal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }),
  /*#__PURE__*/_createTextVNode(" Deslogar ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoutModal = _resolveComponent("LogoutModal")!
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LogoutModal),
    _createElementVNode("header", {
      class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed radius-7',
      { sticky: _ctx.isSticky },
    ]),
      id: "header"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
              id: "header-burger-menu",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.getOperations.length && _ctx.enabledOperationFilter)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOperation) = $event)),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOperationChange && _ctx.onOperationChange(...args))),
                  class: "form-select shadow-none text-black fs-md-15"
                }, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOperations, (operation) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: operation.id,
                      value: operation.id
                    }, _toDisplayString(operation.name), 9, _hoisted_8))
                  }), 128))
                ], 544)), [
                  [_vModelSelect, _ctx.selectedOperation]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_LightDarkSwtichBtn)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getConfigurations.name), 1),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                (_ctx.getConfigurations.role === 'admin')
                  ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(" Configurações "),
                      _createVNode(_component_router_link, {
                        to: "/operations",
                        class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_20
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}